import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import { getUserInfos } from "Flow2/components/CustomCollections/CustomDataControllers/CustomUserController";

export const getDropdownData = ({ item, viewMode = 'advanced', isNoIntl = true }) => {
    if (item && item.options && item.options.length) {
        return item.options.map(option => {
            let value = option.split("=")[0];
            let intl = `dropdown.${viewMode}.${value}`;
            if (item.nointl || isNoIntl) intl = value;
            if (!value) {
                value = "";
                intl = `${viewMode}.select`;
            }
            if (item.optionAsIntl
                || item.params && item.params.profi_search) {
                intl = option.split("=")[1] || "";
            }
            return { name: value, intl, value }
        })
    }

    return [];
}

export const getData = ({ item, users, lg }) => {
    let data;
    if (item.type === aTypes.USERLIST) {
        data = getUserInfos({ storeObj: users, lg, property: "id" });
        data = data.map(entry => ({ name: entry.ID, intl: entry.ID, value: entry.ID }));
        data.unshift(aTypes.DD_SELECT);
    } else data = getDropdownData({ item });
    if (data) item.data = data;
    item.targetType = item.type;
    return item;
}

export const getSearchType = ({ item }) => {
    if (item.params && item.params.profi_search
        && item.params.profi_search.type) {
        return item.params.profi_search.type
    }
    return false;
}

export const getFlexList = ({ item, flexObjects, lg }) => {
    let data = [];
    if (flexObjects && flexObjects.flexTags) data = flexObjects.flexTags;
    let lang = 'DE';
    if (lg) lang = lg.toUpperCase();
    if (data && data.length) {
        data = data.map(entry => ({ value: entry.id, intl: entry[lang] || entry.id, name: entry.id }));
        data.unshift(aTypes.DD_SELECT);
    }
    item.data = data;
    item.targetType = aTypes.DROPDOWN;
    return item;
}

export const getConfigObjects = ({ configObj, configName, users, lg, flexObjects }) => {
    // console.log("LOGS: LAMTEST getConfigObjects configObj ", configObj);
    let config = configObj[configName]
        .filter(item => item.params && item.params.profi_search && item.params.profi_search.show);
    if (config && config.length > 0) {
        config = config.map(original => {
            let item = { ...original };
            let searchType = getSearchType({ item });
            if (searchType && searchType === aTypes.INPUT_NUM) {
                item.type = aTypes.INPUT_NUM;
                item.targetType = aTypes.INPUT_NUM;
            }
            if (item.type === aTypes.TEXT || item.type === aTypes.MASK) item.targetType = aTypes.INPUT;
            if (item.type === aTypes.DYN_TREE || item.type === aTypes.DATE_FROMTO) item.targetType = item.type;
            if (item.type === aTypes.DROPDOWN || item.type === aTypes.MULTISELECT
                || item.type === aTypes.USERLIST
            ) {
                item = getData({ item, users, lg });
            }
            if (searchType && searchType === aTypes.FLEXLIST) {
                item = getFlexList({ item, flexObjects, lg });
            }
            return item;
        });
    }
    return config;
}

export const getSearchTypeFlexDate = () => {
    return [...aTypes.SEARCH_TYPE_FLEXDATE];
}

export const getSearchTypeData = ({ item }) => {
    let searchType = [...aTypes.SEARCH_TYPE_ITEMS];
    if (item && item.params && item.params["form_type"] == aTypes.FLEXDATE) {
        return getSearchTypeFlexDate();
    }
    if (item && item.params && item.params[aTypes.PSEARCH]) {
        let tmp = item.params[aTypes.PSEARCH].searchType;
        let isDate = item.params[aTypes.PSEARCH].isDate;
        let datefield = item.params[aTypes.PSEARCH].datefield;
        let isNumber = item.params[aTypes.PSEARCH].isNumber;
        if (tmp) {
            // Nick
            // if set searchTypes -> all search types must be available
            //searchType = searchType.filter(entry => tmp.some(el => el === entry.name));
            searchType = [...searchType, ...aTypes.SEARCH_TYPE_ADD].filter(entry => tmp.some(el => el === entry.name));
        }
        if (isDate || isNumber || item.type === aTypes.NUMBER || datefield) {
            searchType = [...searchType, ...aTypes.SEARCH_TYPE_ADD];
            // Nick
            // must remove contains -> does not work on solr with this types
            searchType = searchType.filter(entry => entry.name !== 'contains');
        }
    }
    return searchType;
}

